import { render } from "./NVAbbr.vue?vue&type=template&id=5a3d62d8&scoped=true&ts=true"
import script from "./NVAbbr.vue?vue&type=script&lang=ts"
export * from "./NVAbbr.vue?vue&type=script&lang=ts"

import "./NVAbbr.vue?vue&type=style&index=0&id=5a3d62d8&lang=scss&scoped=true"

import exportComponent from "/var/www/html/drupal/modules/custom/nvschade_calculator/assets/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a3d62d8"]])

export default __exports__